import * as type from "../types/single-template";

export const retrieveSingleTemplateDetails = (payload) => {
  return {
    type: type.REQUEST_SINGLE_TEMPLATE_DETAILS,
    payload: payload,
  };
};

export const resetSingleTemplateDetails = () => {
  return {
    type: type.RESET_SINGLE_TEMPLATE_DETAILS,
  };
};

export const setTemplateTitle = (payload) => {
  return {
    type: type.SET_SINGLE_TEMPLATE_TITLE,
    title: payload,
  };
};

export const resetTemplateTitle = () => {
  return {
    type: type.RESET_SINGLE_TEMPLATE_TITLE,
  };
};

export const setSingleTemplateContent = (payload) => {
  return {
    type: type.SET_SINGLE_TEMPLATE_CONTENT,
    content: payload,
  };
};

export const resetSingleTemplateContent = () => {
  return {
    type: type.RESET_SINGLE_TEMPLATE_CONTENT,
  };
};

export const setSingleTemplateHTMLContent = (payload) => {
  return {
    type: type.SET_SINGLE_TEMPLATE_HTML_CONTENT,
    html: payload,
  };
};

export const resetSingleTemplateHTMLContent = () => {
  return {
    type: type.RESET_SINGLE_TEMPLATE_HTML_CONTENT,
  };
};

export const setSingleTemplateMessage = (payload) => {
  return {
    type: type.SET_SINGLE_TEMPLATE_MESSAGE,
    message: payload,
  };
};

export const resetSingleTemplateMessage = () => {
  return {
    type: type.RESET_SINGLE_TEMPLATE_MESSAGE,
  };
};

export const setSingleTemplatePlaintext = (payload) => {
  return {
    type: type.SET_SINGLE_TEMPLATE_PLAINTEXT,
    message: payload,
  };
};

export const resetSingleTemplatePlaintext = () => {
  return {
    type: type.RESET_SINGLE_TEMPLATE_PLAINTEXT,
  };
};

export const requestUpdateSingleTemplate = (payload) => {
  return {
    type: type.REQUEST_UPDATE_SINGLE_TEMPLATE,
    details: payload,
  };
};

export const resetUpdateSingleTemplate = () => {
  return {
    type: type.RESET_UPDATE_SINGLE_TEMPLATE,
  };
};
